import _ from 'lodash';
import Dropdown from 'components/base/Dropdown';
import { getIssueTypesOptions } from '../projects.consts';
import { useProjectsLocalStorage } from '../hooks/useProjectsLocalStorage';

const IssuesTypesToggle = ({
  project,
  issueType,
  projectEstimationFields,
  projectsEstimationFields,
  setProjectsEstimationFields
}) => {
  const { storeProjectsEstimations } = useProjectsLocalStorage();
  return (
    <Dropdown
      width='10rem'
      options={getIssueTypesOptions().map(({ key, displayValue }) => {
        return { value: key, displayValue };
      })}
      selectedValue={projectEstimationFields[issueType]}
      onChange={selected => {
        const projectEstimation = {
          ...projectEstimationFields,
          [issueType]: selected
        };

        const estimations = {
          ...projectsEstimationFields,
          [project.id]: projectEstimation
        };

        storeProjectsEstimations(
          _.get(project, 'name', ''),
          issueType,
          estimations,
          projectEstimation,
          setProjectsEstimationFields
        );
      }}
    />
  );
};

export default IssuesTypesToggle;
